const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热门韩漫日更同步，国漫连载准时上线，追更永远快人一步，再也不用苦等翻译组。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉畅读',
    desc: '专为移动端优化的下拉式阅读模式，无需翻页，一气呵成看完整个章节，沉浸感拉满。',
  },
  {
    icon: 'ri-image-line',
    title: '高清全彩',
    desc: '国漫大图高清全彩呈现，日漫原画级画质，韩漫竖屏适配完美，每一格都是视觉享受。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告干扰，纯净阅读环境，隐私保护到位，专注内容本身，告别乱七八糟的跳转。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            为什么选择皮皮漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            四大核心优势，打造极致的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 md:p-7 hover:bg-background-50/90 transition-colors group cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${f.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}